import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const CreditCardAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-keseharian-anda/cc${props}`,
    {
      headers
    }
  );
};
export default CreditCardAPI;
